import { createElementBlock as C, openBlock as t, createElementVNode as o } from "vue";
const l = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-hours"
};
function n(s, e) {
  return t(), C("svg", l, e[0] || (e[0] = [
    o("path", {
      d: "M25.9655 24H24.2414V9.66667C24.2414 9.22464 24.0597 8.80072 23.7364 8.48816C23.4131 8.17559 22.9745 8 22.5172 8H11.4828C11.0255 8 10.5869 8.17559 10.2636 8.48816C9.94027 8.80072 9.75862 9.22464 9.75862 9.66667V24H8.03448C7.76012 24 7.497 24.1054 7.30299 24.2929C7.10899 24.4804 7 24.7348 7 25C7 25.2652 7.10899 25.5196 7.30299 25.7071C7.497 25.8946 7.76012 26 8.03448 26H25.9655C26.2399 26 26.503 25.8946 26.697 25.7071C26.891 25.5196 27 25.2652 27 25C27 24.7348 26.891 24.4804 26.697 24.2929C26.503 24.1054 26.2399 24 25.9655 24ZM11.8276 10H22.1724V24H11.8276V10ZM20.7931 17.3333C20.7931 17.597 20.7122 17.8548 20.5606 18.0741C20.4091 18.2934 20.1937 18.4643 19.9416 18.5652C19.6896 18.6661 19.4123 18.6925 19.1447 18.641C18.8771 18.5896 18.6314 18.4626 18.4385 18.2761C18.2456 18.0897 18.1142 17.8521 18.061 17.5935C18.0078 17.3348 18.0351 17.0667 18.1395 16.8231C18.2439 16.5795 18.4207 16.3712 18.6475 16.2247C18.8743 16.0782 19.141 16 19.4138 16C19.7796 16 20.1304 16.1405 20.3891 16.3905C20.6478 16.6406 20.7931 16.9797 20.7931 17.3333Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const c = { render: n };
export {
  c as default,
  n as render
};
